const TOKEN_KEY = 'bullmq_admin_token';
const EXPIRES_KEY = 'bullmq_admin_token_expires';
/**
 * Display name of the signed-in operator.
 *
 * Shown in the sidebar so that, with several accounts sharing one browser, an operator can
 * see which identity they are about to send a support reply as — a reply signed by
 * whoever logged in last is the failure this exists to prevent.
 */
const NAME_KEY = 'bullmq_admin_display_name';
/** Username of the signed-in operator — what the account page changes the password of. */
const USER_KEY = 'bullmq_admin_username';

export function getToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const expires = localStorage.getItem(EXPIRES_KEY);
  if (!token || !expires) return null;
  if (new Date(expires) <= new Date()) {
    clearToken();
    return null;
  }
  return token;
}

export function setToken(
  token: string,
  expiresAt: string,
  displayName?: string,
  username?: string,
): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_KEY, expiresAt);
  if (displayName) localStorage.setItem(NAME_KEY, displayName);
  if (username) localStorage.setItem(USER_KEY, username);
}

/** The signed-in operator's username, or null when it is not known. */
export function getUsername(): string | null {
  return localStorage.getItem(USER_KEY);
}

/** The signed-in operator's display name, or null when it is not known. */
export function getDisplayName(): string | null {
  return localStorage.getItem(NAME_KEY);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  localStorage.removeItem(NAME_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}
